export default {"src":"/_next/static/media/white_heart.e1bb5bfc.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};